import { z } from 'zod';
// ---------- Enums ----------
export const TaskStatusSchema = z.enum(['PENDIENTE', 'EN_PROGRESO', 'COMPLETADA', 'CANCELADA']);
export const TaskStatusLabel = {
    PENDIENTE: 'Pendiente',
    EN_PROGRESO: 'En progreso',
    COMPLETADA: 'Completada',
    CANCELADA: 'Cancelada',
};
export const TaskPrioritySchema = z.enum(['BAJA', 'MEDIA', 'ALTA', 'URGENTE']);
export const TaskPriorityLabel = {
    BAJA: 'Baja',
    MEDIA: 'Media',
    ALTA: 'Alta',
    URGENTE: 'Urgente',
};
// ---------- DTOs ----------
export const TaskDtoSchema = z.object({
    id: z.string(),
    opportunityId: z.string().nullable(),
    opportunityCode: z.string().nullable(),
    opportunityTitle: z.string().nullable(),
    title: z.string(),
    description: z.string().nullable(),
    status: TaskStatusSchema,
    priority: TaskPrioritySchema,
    assignedToId: z.string().nullable(),
    assignedToName: z.string().nullable(),
    dueAt: z.string().datetime().nullable(),
    completedAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
    createdByName: z.string().nullable(),
});
export const CreateTaskSchema = z.object({
    opportunityId: z.string().nullable().optional(),
    title: z.string().min(2).max(300),
    description: z.string().max(5000).nullable().optional(),
    status: TaskStatusSchema.default('PENDIENTE'),
    priority: TaskPrioritySchema.default('MEDIA'),
    assignedToId: z.string().nullable().optional(),
    dueAt: z.string().nullable().optional(),
});
export const UpdateTaskSchema = CreateTaskSchema.partial();
export const TaskListQuerySchema = z.object({
    q: z.string().optional(),
    opportunityId: z.string().optional(),
    status: TaskStatusSchema.optional(),
    priority: TaskPrioritySchema.optional(),
    assignedToId: z.string().optional(),
    /** Filtrar por tareas asignadas al usuario actual o creadas por él. */
    mine: z
        .union([z.boolean(), z.enum(['true', 'false'])])
        .transform((v) => v === true || v === 'true')
        .optional(),
    dueBefore: z.string().optional(),
});
export const TaskListResponseSchema = z.object({
    items: z.array(TaskDtoSchema),
});
//# sourceMappingURL=tasks.js.map